import { render } from "./Import_Leads.vue?vue&type=template&id=6d6ad16f"
import script from "./Import_Leads.vue?vue&type=script&lang=js"
export * from "./Import_Leads.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__